import { ImageData, ModelMainSpin } from '../types/common-types';

async function sortImagesByPath(
  modelMainSpin: ModelMainSpin[],
  carImagesPath: string[],
) {
  return await new Promise((resolve) => {
    const sortImageData: ImageData[] = [];

    modelMainSpin.map((model) => {
      carImagesPath.map((image) => {
        const item = model?.filename?.split('/');
        if (image.includes(item[1])) {
          const data = {
            url: image,
            filename: model.filename,
            order: model.order,
          };
          sortImageData.push(data);
        }
      });
    });
    if (sortImageData.length === modelMainSpin?.length) {
      return resolve(sortImageData);
    }
  });
}

export { sortImagesByPath };
